import { render, staticRenderFns } from "./JobBoardsForProductAutocomplete.vue?vue&type=template&id=15162f58&"
import script from "./JobBoardsForProductAutocomplete.vue?vue&type=script&lang=js&"
export * from "./JobBoardsForProductAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./JobBoardsForProductAutocomplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports